class ShareAnalytics {
    static scope = 'share';
}

export { ShareAnalytics };
